const root = document.documentElement;

function apply(theme: "light" | "dark"): void {
  root.dataset.theme = theme;
  try {
    localStorage.setItem("theme", theme);
  } catch {
    /* storage disabled */
  }
}

document.getElementById("theme-toggle")?.addEventListener("click", () => {
  apply(root.dataset.theme === "dark" ? "light" : "dark");
});

// ---- Legal modals (Impressum / Datenschutz) ----
const modal = document.getElementById("legal-modal");
if (modal) {
  const titleEl = modal.querySelector<HTMLElement>(".legal-title");
  const bodyEl = modal.querySelector<HTMLElement>(".legal-body");
  const read = (kind: string): { title: string; html: string } => {
    const el = document.getElementById(`legal-${kind}`);
    if (!el?.textContent) return { title: "", html: "" };
    try {
      return { title: el.dataset.title ?? "", html: JSON.parse(el.textContent) as string };
    } catch {
      return { title: "", html: "" };
    }
  };
  const open = (kind: string): void => {
    const { title, html } = read(kind);
    if (titleEl) titleEl.textContent = title;
    if (bodyEl) bodyEl.innerHTML = html;
    modal.classList.add("open");
  };
  const close = (): void => modal.classList.remove("open");
  document.querySelectorAll<HTMLElement>("[data-legal]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // Also used as an inline link inside the consent label — don't let the
      // click follow the href or toggle the surrounding checkbox.
      e.preventDefault();
      e.stopPropagation();
      open(btn.dataset.legal ?? "imprint");
    });
  });
  modal.querySelector(".legal-close")?.addEventListener("click", close);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
}
